import styled from 'styled-components'
import breakPoint from 'theme/breakpoints'

export const Container = styled.div`
    display: flex;
    flex: 1;
    height: 100dvh;
    flex-direction: column;

    ${breakPoint.desktop} {
        flex-direction: row-reverse;
    }
`

export const ContainerContent = styled.section<{ bgColor?: string }>`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: flex-start;
    padding: 1.5rem 1rem;
    background: ${({ bgColor }) => bgColor};

    ${breakPoint.desktop} {
        display: flex;
        flex: 3;
        justify-content: center;
        align-items: center;
        padding: 0 1rem;
        background: #fff;
    }
`

export const ContainerPage = styled.div`
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    max-width: 434px;
    justify-self: center;
    flex: 1;
    border-radius: 0.5rem;
    background-color: #fff;
    padding: 2rem 1.5rem 1.5rem;
    box-shadow: 0px 8px 24px 0px rgba(22, 22, 22, 0.08), 0px 4px 4px 0px rgba(22, 22, 22, 0.04);

    ${breakPoint.desktop} {
        display: flex;
        flex-direction: column;
        align-self: center;
        justify-self: center;
        flex: 1;
        max-width: 25.5rem;
        box-shadow: none;
    }
`

export const CustomLogo = styled.img`
    height: 2rem;
    align-self: flex-start;
`
